const LABEL_KEYS = ['reason', 'name', 'label', 'title', 'code'] as const

function sortOrderOf(item: unknown): number {
  if (typeof item !== 'object' || item == null || !('sort_order' in item)) return 0
  const n = Number((item as { sort_order?: unknown }).sort_order)
  return Number.isFinite(n) ? n : 0
}

export function formatJsonListItem(item: unknown): string {
  if (item == null) return ''
  if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
    return String(item)
  }
  if (typeof item !== 'object') return ''
  const obj = item as Record<string, unknown>
  if (obj.is_active === false) return ''
  for (const key of LABEL_KEYS) {
    const v = obj[key]
    if (typeof v === 'string' && v.trim()) return v.trim()
    if (typeof v === 'number') return String(v)
  }
  return ''
}

export function formatJsonListDisplay(value: unknown): string {
  if (!Array.isArray(value) || value.length === 0) return '—'
  const labels = [...value]
    .sort((a, b) => sortOrderOf(a) - sortOrderOf(b))
    .map(formatJsonListItem)
    .filter(Boolean)
  return labels.length > 0 ? labels.join(', ') : '—'
}
